import React,{useEffect, useState} from "react";
import {Outlet, Link, Navigate} from "react-router-dom";
import axios from "axios";
import Appbar from "../Appbar";
import SelectCustomer from "../Customer/SelectCustomer";
import {
    CircularProgress, Fab, Grid, IconButton, Paper, Table, TableBody, TableCell, tableCellClasses,
    TableContainer, TableHead, TableRow
} from "@mui/material";
import {styled} from "@mui/material/styles";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const FactorList = () =>{
    const [loading , setLoading] = React.useState(true);
    const [factorList , setFactorList] = useState("");
    const [change , setChange] = React.useState(false);
    const [dialogSelectCustomer, setDialogSelectCustomer] = React.useState(false);
    const [msgsucc , setMsgsucc] = React.useState(true);
    const [isLogin] = useState(localStorage.getItem("islogin"));
    const [errorMsg , setErrorMsg] = useState("");
    const [succsMsg , setSuccsMsg] = useState("");
    localStorage.removeItem('cstname');
    localStorage.removeItem('csttel');
    localStorage.removeItem('cstaddress');
    localStorage.removeItem('cstid');
    localStorage.removeItem('ftype');
    useEffect(async () => {
        setLoading(true);
        const req = axios.create();
        req.defaults.timeout = 5000;
        await req.get("https://app.zhivay.com/api/get_factorlist.php")
            .then(respone => {
                setFactorList(respone.data);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                console.log(error);
            });
        setChange(false);
        setDialogSelectCustomer(false);
    },[change]);

    const hendel_edit_click =()=>{

    }
    const Redirect = ()=>{
        return (<Navigate replace to="/login" />)
    }
    return (
        <div>
            {isLogin !== "true" ? <Redirect/> : ''}
            <Appbar/>
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center">
                <Fab
                    color="primary"
                    sx={{ position: 'absolute', bottom: 16, right: 16 }}
                    aria-label="add"
                    onClick={()=>{setDialogSelectCustomer(true)}}
                >
                    <AddIcon />
                </Fab>

                {!loading ?
                    <TableContainer component={Paper} sx={{margin:2}}>
                        <Table sx={{ minWidth: 250,maxHeight:'80%',overflowY:'auto',}} className='tbl-pishfactor'>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="left">عملیات</StyledTableCell>
                                    <StyledTableCell align="right">تاریخ</StyledTableCell>
                                    <StyledTableCell align="right">نام مشتری</StyledTableCell>
                                    <StyledTableCell align="right">شماره فاکتور</StyledTableCell>
                                    <StyledTableCell align="right"></StyledTableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {factorList.map(factor => (
                                    <StyledTableRow
                                        component={Link} to={`factors/${factor.factor_key}/`}
                                        onClick={()=>hendel_edit_click(factor.factor_key)}
                                        key={factor.factor_key}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <StyledTableCell align="left">
                                            <IconButton
                                                onClick={()=>hendel_edit_click(factor.factor_key)}
                                                aria-label="view"><EditIcon color={"primary"} /></IconButton>
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row" align="right">
                                            {factor.date}
                                        </StyledTableCell>
                                        <StyledTableCell component="th" scope="row" align="right">{factor.customer_name}</StyledTableCell>
                                        <StyledTableCell sx={{borderRight:"10px #000000"}} align="right">
                                            {factor.factor_number}
                                        </StyledTableCell>
                                        <StyledTableCell sx={{backgroundColor:"#fabc5b",textAlign:"right",width:2}} align="right">
                                            <p style={{fontSize:"10px",
                                                writingMode:"vertical-rl",
                                            margin:0
                                            }}> پیش فاکتور </p>
                                        </StyledTableCell>
                                    </StyledTableRow >
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                : <CircularProgress sx={{margin:2}} /> }
            </Grid>
            {dialogSelectCustomer ?
                <SelectCustomer setChange={setChange}/>
            : ''}
        </div>
    )
}

export default FactorList;